var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg004Back(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3599 20.71C13.5462 20.8947 13.7976 20.9989 14.0599 21C14.3272 20.9989 14.5829 20.8908 14.7699 20.7C15.1577 20.31 15.1577 19.68 14.7699 19.29L7.41994 12L14.7699 4.69999C14.9593 4.51222 15.0657 4.25663 15.0657 3.98999C15.0657 3.72335 14.9593 3.46776 14.7699 3.27999C14.3799 2.89227 13.75 2.89227 13.3599 3.27999L5.28994 11.28C5.10063 11.4678 4.99414 11.7234 4.99414 11.99C4.99414 12.2566 5.10063 12.5122 5.28994 12.7L13.3599 20.71Z",
    fill: "#8199A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg004Back);
export default __webpack_public_path__ + "static/media/004-back.83964753085ce18a8e5c075578826b33.svg";
export { ForwardRef as ReactComponent };